import makeRequest from './base.request'
import { STAGE_TYPE } from '../const';

export const getTrilha = async () => {
    try {
        //Mock Data
        // return [
        //     {
        //         idPeriodSchoolGrade: 2254,
        //         nuPeriod: 1,
        //         txPeriodPracticeTest: "1º Trimestre",
        //         dtStartPeriod: "2019-02-19",
        //         dtEndPeriod: "2019-05-25",
        //         PeriodActive: 1,
        //         PeriodEnabled: 1,
        //         idPeriodPracticeTest: 217,
        //         idPracticeTestType: 1,
        //         txPracticeTestType: "Simulado Diagnóstico",
        //         inLockedPracticeTest: 0,
        //         inLockedLearningTrack: 1,
        //         idExam: 187,
        //         idEvent: 191,
        //         dtStartEvent: "2019-03-20",
        //         idExamTaken: undefined,
        //         idExamTakenStatus: 4
        //     }
        // ];

        const response = await makeRequest.get('periodos/aluno');

        var periodos = response.periodos;
        return periodos;
        
    } catch (error) {
        console.error(error);
    }
}

export const getEstudos = async (periodosimulado, estudosAdicionados) => {
    try {
        //Mock Data
        // var mockData = {
        //     "estudos":[
        //         {"idStudentStudy":1,"txStudy":"O Princípio da Física de Newton","txStudyDetails":"2 páginas","inDifficultyLevel":2,"txStudyType":"Material Didático Digital","txStudyTypeAbr":"MDD","dtStartStudy":"2019-05-06T15:01:23.017Z","dtEndStudy":"2019-05-08T15:01:23.017Z","inStatusStudy":"1","obUrlThumbnail":"/images/estudos/estudo3.png","disciplines":[{"txDiscipline":"Física"}]},
        //         {"idStudentStudy":2,"txStudy":"A Terra e a Lua","txStudyDetails":"2 páginas","inDifficultyLevel":2,"txStudyType":"Material Didático Digital","txStudyTypeAbr":"MDD","dtStartStudy":"2019-05-06T15:01:31.593Z","dtEndStudy":"2019-05-08T15:01:31.593Z","inStatusStudy":"1","obUrlThumbnail":"/e/img/cover/mfs1/001.png","disciplines":[{"txDiscipline":"Física"}]},
        //         {"idStudentStudy":3,"txStudy":"Forças variáveis","txStudyDetails":"2 páginas","inDifficultyLevel":2,"txStudyType":"Material Didático Digital","txStudyTypeAbr":"MDD","dtStartStudy":"2019-05-06T15:01:37.937Z","dtEndStudy":"2019-05-08T15:01:37.937Z","inStatusStudy":"1","obUrlThumbnail":"/e/img/cover/mfs1/001.png","disciplines":[{"txDiscipline":"Física"}]}
        //     ]
        // };
        // return mockData.estudos;

        

        const response = await makeRequest.get(`estudo/aluno?periodosimulado=${periodosimulado}&estudosugerido=${ estudosAdicionados ? '0' : '1' }`);
        return response.estudos;
        
    } catch (error) {
        console.error(error);
    }
}


export const getInfoEstudo = async (idStudentStudy, idUserStudent) => {
    try {
        ////Mock Data
        // var response = {
        //     "instrucao": [
        //         {
        //             "idStudy": 21,
        //             "idStudyType": 1,
        //             "txStudy": "O Princípio da Física de Newton",
        //             "txStudyDetails": "2 páginas",
        //             "inDifficultyLevel": 2,
        //             "inImproveStudy": false,
        //             "idAccount": 5922,
        //             "dtStartStudy": "2019-05-06T15:01:23.017Z",
        //             "dtEndStudy": "2019-05-08T15:01:23.017Z",
        //             "nuQuestions": 1,
        //             "canStart": 0,
        //             "hasExpired": 1,
        //             "canViewCorrection": 0,
        //             "hasStarted": 0,
        //             "abilities": [
        //                 {
        //                     "txAbility": "H19 - Avaliar métodos, processos ou procedimentos das ciências naturais que contribuam para diagnosticar ou solucionar problemas de ordem social, econômica ou ambiental."
        //                 },
        //                 {
        //                     "txAbility": "H20 - Caracterizar causas ou efeitos dos movimentos de partículas, substâncias, objetos ou corpos celestes."
        //                 },
        //                 {
        //                     "txAbility": "H21 - Utilizar leis físicas e (ou) químicas para interpretar processos naturais ou tecnológicos inseridos no contexto da termodinâmica e(ou) do eletromagnetismo."
        //                 }
        //             ],
        //             "stages": [
        //                 {
        //                     "nuOrder": 1,
        //                     "idStudyStage": 21,
        //                     "idStageType": 1,
        //                     "txStageType": "Estude o conteúdo"
        //                 },
        //                 {
        //                     "nuOrder": 2,
        //                     "idStudyStage": 158,
        //                     "idStageType": 2,
        //                     "txStageType": "Faça um resumo"
        //                 },
        //                 {
        //                     "nuOrder": 3,
        //                     "idStudyStage": 326,
        //                     "idStageType": 3,
        //                     "txStageType": "Responda a questão"
        //                 }
        //             ]
        //         }
        //     ]
        // };

        const response = await makeRequest.get(`estudo/informacao?studentstudy=${idStudentStudy}${idUserStudent?`&student=${idUserStudent}`:''}`);        
        return (response && response.instrucao && response.instrucao[0]) || {};
        
    } catch (error) {
        console.error(error);
    }
}

export const getDadosEtapaEstudo = async (idStudentStudy, stage, idUserStudent) => {
    try {

        const response = await makeRequest.get(`estudo/etapa?studentstudy=${idStudentStudy}&stage=${stage}${idUserStudent?`&student=${idUserStudent}`:''}`);       
        return (response && response.etapas) || [];
        
    } catch (error) {
        console.error(error);
        
    }
}


export const setDadosEtapaConteudo = async (idStudentStudy, idStudyStage, realizado) => {
    try {
        var postData = {
            idStudentStudy: idStudentStudy,
            stages: [
                {
                    idStudyStage: idStudyStage,
                    idStageType: STAGE_TYPE.CONTEUDO,
                    inStatus: realizado ? 'R': ''
                }
            ]
        }
        const response = await makeRequest.post('estudo/etapa', postData);
        return response;
        
    } catch (error) {
        console.error(error);
    }
}

export const setDadosEtapaResumo = async (idStudentStudy, idStudyStage, txAnswer, realizado) => {
    try {
        var postData = {
            idStudentStudy: idStudentStudy,
            stages: [
                {
                    idStudyStage: idStudyStage,
                    idStageType: STAGE_TYPE.RESUMO,
                    txAnswer: txAnswer,
                    inStatus: realizado ? 'R': ''
                }
            ]
        }
        console.log('setDadosEtapaResumo postData ',postData)

        const response = await makeRequest.post('estudo/etapa', postData);
        return response;
        
    } catch (error) {
        console.error(error);
    }
}

export const setDadosEtapaQuestoes = async (idStudentStudy, idStudyStage, answers, realizado) => {
    try {
        var postData = {
            idStudentStudy: idStudentStudy,
            stages: [
                {
                    idStudyStage: idStudyStage,
                    idStageType: STAGE_TYPE.QUESTOES,
                    answers: answers,
                    inStatus: realizado ? 'R': ''
                }
            ]
        }
        const response = await makeRequest.post('estudo/etapa', postData);
        return response;
        
    } catch (error) {
        console.error(error);
    }
}

export const setDadosEtapaAvaliarConteudo = async (idStudentStudy, idStudyStage, nuScore, txAnswer, realizado) => {
    try {
        console.log('Score ', nuScore)
        var postData = {
            idStudentStudy: idStudentStudy,
            finishStudy: realizado, //A avaliação do conteúdo finaliza o estudo
            stages: [
                {
                    idStudyStage: idStudyStage,
                    idStageType: STAGE_TYPE.AVALIAR_CONTEUDO,
                    nuScore: nuScore,
                    txAnswer: txAnswer,
                    inStatus: realizado ? 'R': ''
                }
            ]
        }
        console.log('posttt setDadosEtapaAvaliarConteudo ', postData)
        const response = await makeRequest.post('estudo/etapa', postData);
        return response;
        
    } catch (error) {
        console.error(error);
    }
}

export const setAddEstudoAluno = async (idStudy, idPeriodPracticeTest) => {
    try {
        var postData = {
            idStudy: idStudy,
            idPeriodPracticeTest: idPeriodPracticeTest
        }
        const response = await makeRequest.post('estudo/aluno', postData);
        return response.incluido;
        
    } catch (error) {
        console.error(error);
    }
}